import {
  useGetDailyDishIngredientsQuery,
  useLinkIngredientToDailyDishMutation,
  useRemoveDailyDishIngredientMutation,
  useUpdateDailyDishIngredientMutation,
} from "@/redux/services/inventory/recipe.api";
import RecipeIngredientsManager from "./RecipeIngredientsManager";
import { usePermissions } from "@/hooks/usePermissions";

interface DailyDishIngredientsProps {
  dailyDishId: string;
  restaurantId: string;
}

const DailyDishIngredients = ({
  dailyDishId,
  restaurantId,
}: DailyDishIngredientsProps) => {
  // Recipes are read with inventory.view and written with inventory.manage.
  const { canManage } = usePermissions();
  const { data, isLoading } = useGetDailyDishIngredientsQuery({
    dailyDishUuid: dailyDishId,
  });
  const [link, { isLoading: isLinking }] =
    useLinkIngredientToDailyDishMutation();
  const [remove] = useRemoveDailyDishIngredientMutation();
  const [update, { isLoading: isUpdating }] =
    useUpdateDailyDishIngredientMutation();

  return (
    <RecipeIngredientsManager
      readOnly={!canManage("inventory")}
      restaurantId={restaurantId}
      linkedIngredients={data?.results ?? []}
      isLoading={isLoading}
      isLinking={isLinking}
      isUpdating={isUpdating}
      emptyTitle="Aucun ingrédient lié à ce plat"
      emptySubtitle="S'il n'y a pas d'ingrédients, la recette du plat de menu associé sera utilisée."
      onLink={async (payload) => {
        const res = await link({
          dailyDishUuid: dailyDishId,
          data: payload,
        });
        return "data" in res ? { ok: true } : { ok: false };
      }}
      onRemove={async (mapping) => {
        const res = await remove({
          dailyDishUuid: dailyDishId,
          mappingUuid: mapping.id,
        });
        return "error" in res ? { ok: false } : { ok: true };
      }}
      onUpdate={async (mapping, args) => {
        const res = await update({
          dailyDishUuid: dailyDishId,
          mappingUuid: mapping.id,
          data: args,
        });
        return "error" in res ? { ok: false } : { ok: true };
      }}
    />
  );
};

export default DailyDishIngredients;
